import React from 'react';
import styles from './index.css';
import errorBoundary from '@ifeng-fe/errorBoundary';
import { WxLaunchHack } from '@ifeng-fe/three_terminal/es/mobile/wxLaunchHack/dynamic';
import { getQuery } from '@src/utils/index';

const BottomColumn = () => {
    const date = getQuery(location.href, 'date');
    const dataParam = date ? `date=${date}` : '';
    const nineDomain = typeof window === 'object' && window.allData?.__nd__ ? window.allData.__nd__ : 'ne883dbn.ifeng.com';
    const wxLaunchHackData = {
        callAppConfig: {
            docType: 'aiSummaryList',
            pid: `https://${ nineDomain }/getaisummarylist?${dataParam}`,
            kind: 'inter_aijianbao02',
            noKindFrom: 1,
            download: 'http://a.app.qq.com/o/simple.jsp?pkgname=com.ifeng.news2&ckey=CK7199258696283235328',
            downloadAd: 'https://statistics.appstore.ifeng.com/index.php/api/godownload?app_id=4&d_ch=9087',
        },
        statisticsConfig: {
            behavior: 'action',
            type: 'aibriefbtm',
        },
    };

    return (
        <div className={styles.bottomColumn}>
            <div className={styles.bottomColumnBox}>
                <img className={styles.bottomColumnPic} src="https://x0.ifengimg.com/ucms/2021_31/31A0009714B77C212C710F60DBC83CB0AF8AAD57_size20_w750_h112.png" />
                <WxLaunchHack content={wxLaunchHackData} />
            </div>
        </div>
    );
};

export default errorBoundary(BottomColumn);
